import { Button } from "react-bootstrap";
import { useRef, useState, useEffect, useCallback } from "react";
import * as APIModels from "../../../../models";
import Select, { ActionMeta } from "react-select";
import { SubmissionService } from "../../../../services/SubmissionService";
import CaseSearch from "../CaseSearch";
import Pleadings from "../Pleadings";
import Fees from "../Fees";
import { EmptyGuid } from "../../../../models";
import { useParams } from "react-router-dom";
import TylerPleadings from "../TylerPleadings";
import { Checkbox } from "@material-ui/core";
import CaseSearchLong from "../CaseSearchLong";
import NotesModal from "../modals/NotesModal";

type MyOptionType = { label: string; value: string };

interface QueryParams {
    submissionId?: string;
    attorneyId?: string;
    filter?: string;
    state?: string;
}

export default function ExistingCase({
    submission,
    onSelectDocument,
    setNextSubmission,
    filter,
}: {
    submission: APIModels.Submission;
    onSelectDocument: (doc: APIModels.Document, index: number) => void;
    setNextSubmission: (next: APIModels.Submission) => void;
    filter?: string;
}) {
    const [completedSubmission, setCompletedSubmission] = useState(submission);
    const [completedDocs, setCompletedDocs] = useState(submission.documents!);
    const [completedFees, setCompletedFees] = useState(submission.fees ?? []);
    const [submitting, setSubmitting] = useState(false);
    const [caseAlert, setCaseAlert] = useState("");
    const [caseAlertCycles, setCaseAlertCycles] = useState(0);
    const [override, setOverride] = useState(false);
    const [feePay, setFeepay] = useState(submission.feePay ?? false);
    const [feeLoading, setFeeLoading] = useState<boolean>(false);
    const [notesCheck, setNotesCheck] = useState(false);

    const [showParties, setShowParties] = useState(false);
    const partiesDiv = useRef<HTMLDivElement>(null);
    const [showNotesModal, setShowNotesModal] = useState(
        (submission.notes?.map((o, i) => o.note ?? "")?.join(" ") ?? "")
            .length > 0
    );

    useEffect(() => {
        setCompletedSubmission(submission);
    }, [submission]);

    const handleFeeLoading = () => {
        console.log({ "Handeling fees loading: ": !feeLoading });
        setFeeLoading((prev) => {
            return !prev;
        });
    };

    const onSearchComplete = (
        request: APIModels.CaseSearch,
        result: APIModels.CourtCase
    ) => {
        const updatedCaseData =
            completedSubmission.caseData ?? new APIModels.CaseData();
        updatedCaseData.ucn = result.ucn;
        updatedCaseData.county = result.county;
        updatedCaseData.countyID = request.countyID;
        updatedCaseData.division = result.division;
        updatedCaseData.divisionID =
            result.divisionID && result.divisionID != EmptyGuid
                ? result.divisionID
                : request.divisionID;
        updatedCaseData.courtCaseNumber =
            result.caseNumber ?? request.caseNumber;
        updatedCaseData.caseTitle = result.caseTitle;
        updatedCaseData.caseTypeID = result.caseTypeID;
        updatedCaseData.caseSubTypeID = result.caseSubTypeID;
        updatedCaseData.year = request.year;
        updatedCaseData.sequenceNumber = request.sequenceNumber;

        setCompletedSubmission({
            ...submission,
            caseData: updatedCaseData,
            parties: result.parties,
        });
        setCaseAlert("red-fade-in");
    };

    const onUpdateDoc = (doc: APIModels.Document) => {
        const docs = [...completedDocs!];
        const index = completedDocs?.findIndex((v) => v.id == doc.id);
        docs[index!].documentType = doc.documentType;
        docs[index!].documentTypeID = doc.documentTypeID;
        docs[index!].fees = doc.fees;
        docs[index!].description = doc.description;
        docs[index!].filingCodeID = doc.filingCodeID;
        docs[index!].filingComponentID = doc.filingComponentID;
        docs[index!].securityID = doc.securityID ? doc.securityID : EmptyGuid;
        docs[index!].optionalServices = doc.optionalServices;
        // console.log(docs);
        setCompletedDocs(docs);
    };

    const onFeeChange = (fees: APIModels.FeeType[]) => {
        setCompletedFees(fees);
    };

    const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        setSubmitting(true);
        SubmissionService.submit({
            attorneyId: completedSubmission.attorneyID,
            filter: filter,
            state: completedSubmission.portalIdentifier,
            body: {
                ...completedSubmission,
                documents: completedDocs,
                fees: completedFees,
                override: override,
                feePay: feePay,
            },
        }).then(
            (resp) => {
                console.log(resp);
                if (resp.data && resp.data.id) {
                    //show efile success
                    //setNextSubmission(resp.data);
                    window.location.href = `/efile?submissionId=${resp.data.id}&filter=${filter}`;
                } else {
                    //TODO: Show error
                    window.location.href = "/queue/" + filter;
                }
            },
            (error) => {
                setSubmitting(false);
                window.location.href = "/queue/" + filter;
            }
        );
        e.preventDefault();
    };

    useEffect(() => {
        if (caseAlert === "red-fade-out") {
            setTimeout(() => setCaseAlert("red-fade-in"), 500);
        } else if (caseAlert === "red-fade-in") {
            setTimeout(() => setCaseAlert(""), 1000);
        } else if (caseAlert === "" && caseAlertCycles < 3) {
            setTimeout(() => setCaseAlert("red-fade-out"), 1000);
            setCaseAlertCycles(caseAlertCycles + 1);
        } else {
            setCaseAlertCycles(0);
        }
    }, [caseAlert]);

    window.addEventListener("keydown", (event: KeyboardEvent) => {
        switch (event.code) {
            case "F1":
                event.stopPropagation();
                event.stopImmediatePropagation();
                event.cancelBubble = true;
                event.preventDefault();
                event.returnValue = false;
                (
                    document.getElementById("flush-headingOne")
                        ?.firstElementChild as HTMLButtonElement
                ).click();

                break;
            case "F2":
                event.stopPropagation();
                event.stopImmediatePropagation();
                event.cancelBubble = true;
                event.preventDefault();
                event.returnValue = false;
                (
                    document.getElementById("flush-headingTwo")
                        ?.firstElementChild as HTMLButtonElement
                ).click();
                break;
            case "F3":
                event.stopPropagation();
                event.stopImmediatePropagation();
                event.cancelBubble = true;
                event.preventDefault();
                event.returnValue = false;
                (
                    document.getElementById("flush-headingThree")
                        ?.firstElementChild as HTMLButtonElement
                ).click();
                break;
            default:
                break;
        }
    });

    const hoverShowParties = useCallback(() => {
        const rect = partiesDiv.current?.getBoundingClientRect() ?? null;
        if (rect === null) {
            setShowParties(false);
            return;
        }
        return (
            <div
                style={{
                    position: "fixed",
                    top: rect.top,
                    left: rect.left,
                    width: "400px",
                    backgroundColor: "white",
                    pointerEvents: "none",
                    padding: "10px",
                    border: "1px solid #DDD",
                    borderRadius: "8px",
                    zIndex: 100,
                }}
            >
                <table>
                    {completedSubmission.parties
                        ?.filter((v) => v.partyType?.indexOf("Attorney") == -1)
                        .map((v) => (
                            <tr>
                                <td>{v.partyType}</td>
                                <td>
                                    {v.name
                                        ? v.name
                                        : v.firstName + " " + v.lastName}
                                </td>
                            </tr>
                        ))}
                </table>
            </div>
        );
    }, [completedSubmission]);

    const handleMouseOver = (event: React.MouseEvent<HTMLElement>) => {
        setShowParties(true);
    };

    const handleMouseOut = (event: React.MouseEvent<HTMLImageElement>) => {
        setShowParties(false);
    };
    const onCancelNotes = () => {
        setShowNotesModal(false);
        setNotesCheck(false);
    };
    const onConfirmNotes = () => {
        setShowNotesModal(false);
        setNotesCheck(false);
    };
    return (
        <>
            <form className="needs-validation" onSubmit={onSubmit}>
                <NotesModal
                    show={showNotesModal}
                    onCancelNotes={onCancelNotes}
                    onConfirmNotes={onConfirmNotes}
                    notes={
                        submission.notes
                            ?.map((o, i) => o.note ?? "")
                            ?.join(" ") ?? ""
                    }
                ></NotesModal>
                <div>
                    <div
                        className="mb-3"
                        ref={partiesDiv}
                        onMouseEnter={handleMouseOver}
                        onMouseLeave={handleMouseOut}
                    >
                        {showParties && hoverShowParties()}
                        <label className="form-label">UCN</label>
                        <a style={{ display: "block" }}>
                            {completedSubmission.caseData?.ucn}
                        </a>
                    </div>
                    <div className={`mb-3 ${caseAlert}`}>
                        {(completedSubmission.caseData?.caseTitle === "" ||
                            completedSubmission.caseData?.caseTitle === null) &&
                        completedSubmission.caseData?.ucn != "" &&
                        completedSubmission.caseData?.ucn != null ? (
                            <>
                                <label className="form-label">Case Found</label>
                                <div>
                                    <b>
                                        Case Number :{" "}
                                        {
                                            completedSubmission.caseData
                                                ?.courtCaseNumber
                                        }
                                    </b>
                                    <b></b>
                                </div>
                            </>
                        ) : (
                            <>
                                <label className="form-label">Case Title</label>
                                <div>
                                    <b>
                                        {
                                            completedSubmission.caseData
                                                ?.caseTitle
                                        }
                                    </b>
                                </div>
                            </>
                        )}
                    </div>
                </div>
                <div
                    className="accordion accordion-flush"
                    id="accordionFlushExample"
                >
                    <div className="accordion-item">
                        <h2 className="accordion-header" id="flush-headingOne">
                            <button
                                className="accordion-button"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#flush-collapseOne"
                                aria-expanded="true"
                                aria-controls="flush-collapseOne"
                            >
                                Case Search
                            </button>
                        </h2>
                        <div
                            id="flush-collapseOne"
                            className="accordion-collapse collapse show"
                            aria-labelledby="flush-headingOne"
                            data-bs-parent="#accordionFlushExample"
                        >
                            <div className="accordion-body">
                                <CaseSearchLong
                                    submission={completedSubmission}
                                    onSearchComplete={onSearchComplete}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="accordion-item">
                        <h2 className="accordion-header" id="flush-headingTwo">
                            <button
                                className="accordion-button collapsed"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#flush-collapseTwo"
                                aria-expanded="false"
                                aria-controls="flush-collapseTwo"
                            >
                                Documents
                            </button>
                        </h2>
                        <div
                            id="flush-collapseTwo"
                            className="accordion-collapse collapse"
                            aria-labelledby="flush-headingTwo"
                            data-bs-parent="#accordionFlushExample"
                        >
                            <div className="accordion-body">
                                {submission.portalIdentifier == "TX" ||
                                submission.portalIdentifier == "IL" ||
                                submission.portalIdentifier == "IN" ||
                                submission.portalIdentifier == "NC" ||
                                submission.portalIdentifier == "CA" ||
                                (submission.portalIdentifier == "GA" &&
                                    completedSubmission.caseData &&
                                    completedSubmission.caseData.caseTypeID !=
                                        APIModels.EmptyGuid) ||
                                submission.portalIdentifier == "MD" ? (
                                    <TylerPleadings
                                        submission={completedSubmission}
                                        originalDocs={completedDocs}
                                        onSelectDocument={onSelectDocument}
                                        onUpdateDoc={onUpdateDoc}
                                    />
                                ) : (
                                    <Pleadings
                                        submission={completedSubmission}
                                        originalDocs={completedDocs}
                                        onSelectDocument={onSelectDocument}
                                        onUpdateDoc={onUpdateDoc}
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="accordion-item">
                        <h2
                            className="accordion-header"
                            id="flush-headingThree"
                        >
                            <button
                                className="accordion-button collapsed"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#flush-collapseThree"
                                aria-expanded="false"
                                aria-controls="flush-collapseThree"
                            >
                                Fees
                            </button>
                        </h2>
                        <div
                            id="flush-collapseThree"
                            className="accordion-collapse collapse"
                            aria-labelledby="flush-headingThree"
                            data-bs-parent="#accordionFlushExample"
                        >
                            <div className="accordion-body">
                                <Fees
                                    submission={completedSubmission}
                                    fees={completedFees}
                                    handleFeeLoading={handleFeeLoading}
                                    onFeeChange={onFeeChange}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12" style={{ textAlign: "center" }}>
                        {submitting ? (
                            <button
                                className="btn btn-primary"
                                type="button"
                                disabled={true}
                            >
                                <span
                                    className="spinner-border spinner-border-sm me-1"
                                    role="status"
                                    aria-hidden="true"
                                ></span>
                                Submitting...
                            </button>
                        ) : (
                            <button
                                className="btn btn-primary"
                                type="submit"
                                disabled={
                                    submission.notes != null &&
                                    submission.notes != undefined &&
                                    submission.notes.length > 0 &&
                                    submission.notes[0].note != "" &&
                                    notesCheck == false
                                }
                            >
                                Submit
                            </button>
                        )}
                    </div>
                </div>
                {submission.notes != null &&
                submission.notes != undefined &&
                submission.notes.length > 0 &&
                submission.notes[0].note != "" ? (
                    <div className="row">
                        <div
                            className="col-12 mt-2"
                            style={{
                                display: "flex",
                                justifyContent: "center",
                            }}
                        >
                            <div
                                className="form-check"
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                }}
                            >
                                <input
                                    className="form-check-input me-2"
                                    id="ckNotes"
                                    type="checkbox"
                                    checked={notesCheck}
                                    onChange={(event) =>
                                        setNotesCheck(
                                            event.currentTarget.checked
                                        )
                                    }
                                />
                                <label
                                    htmlFor="ckNotes"
                                    className="form-check-label"
                                >
                                    Notes Acknowledgment
                                </label>
                            </div>
                        </div>

                        <div
                            className="col-12 mt-3"
                            style={{ textAlign: "center" }}
                        >
                            <button
                                className="btn btn-primary"
                                type="button"
                                onClick={() => {
                                    setShowNotesModal(true);
                                    setNotesCheck(false);
                                }}
                            >
                                Check Notes
                            </button>
                        </div>
                    </div>
                ) : (
                    <></>
                )}
                <div className="row mt-2">
                    <div
                        className="col-12"
                        style={{
                            display: "flex",
                            justifyContent: "center",
                        }}
                    >
                        <div
                            className="col-2"
                            style={{
                                display: "flex",
                                justifyContent: "center",
                            }}
                        >
                            <div className="form-check">
                                <input
                                    className="form-check-input"
                                    id="ckOverride"
                                    type="checkbox"
                                    checked={override ?? false}
                                    onChange={(event) =>
                                        setOverride(event.currentTarget.checked)
                                    }
                                />
                                <label
                                    className="form-check-label"
                                    htmlFor="ckOverride"
                                >
                                    Override
                                </label>
                            </div>
                        </div>
                        <div
                            className="col-2"
                            style={{
                                display: "flex",
                                justifyContent: "center",
                            }}
                        >
                            <div className="form-check">
                                <input
                                    className="form-check-input"
                                    id="ckFeePay"
                                    type="checkbox"
                                    checked={feePay ?? false}
                                    onChange={(event) =>
                                        setFeepay(event.currentTarget.checked)
                                    }
                                />
                                <label
                                    htmlFor="ckFeePay"
                                    className="form-check-label"
                                >
                                    Fee Pay
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </>
    );
}
